import InterestApi from 'Api/interest';
import { push } from 'react-router-redux';

export const INTEREST_CREATE_REQUEST = 'INTEREST_CREATE_REQUEST';
export const INTEREST_CREATE_SUCCESS = 'INTEREST_CREATE_SUCCESS';
export const INTEREST_CREATE_ERROR = 'INTEREST_CREATE_ERROR';

export const INTEREST_LIST_REQUEST = 'INTEREST_LIST_REQUEST';
export const INTEREST_LIST_SUCCESS = 'INTEREST_LIST_SUCCESS';
export const INTEREST_LIST_ERROR = 'INTEREST_LIST_ERROR';
export const INTEREST_LIST_UPDATE_FILTER = 'INTEREST_LIST_UPDATE_FILTER';

export const INTEREST_AUTOCOMPLETE_REQUEST = 'INTEREST_AUTOCOMPLETE_REQUEST';
export const INTEREST_AUTOCOMPLETE_SUCCESS = 'INTEREST_AUTOCOMPLETE_SUCCESS';
export const INTEREST_AUTOCOMPLETE_ERROR = 'INTEREST_AUTOCOMPLETE_ERROR';

export const INTEREST_DESTROY_REQUEST = 'INTEREST_DESTROY_REQUEST';
export const INTEREST_DESTROY_SUCCESS = 'INTEREST_DESTROY_SUCCESS';
export const INTEREST_DESTROY_ERROR = 'INTEREST_DESTROY_ERROR';

export const INTEREST_DATA_REQUEST = 'INTEREST_DATA_REQUEST';
export const INTEREST_DATA_SUCCESS = 'INTEREST_DATA_SUCCESS';
export const INTEREST_DATA_ERROR = 'INTEREST_DATA_ERROR';

export const INTEREST_UPDATE_REQUEST = 'INTEREST_UPDATE_REQUEST';
export const INTEREST_UPDATE_SUCCESS = 'INTEREST_UPDATE_SUCCESS';
export const INTEREST_UPDATE_ERROR = 'INTEREST_UPDATE_ERROR';

/**
 * Create interest
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function createInterest(data) {
    return {
        requestType: 'INTEREST_CREATE',
        request: InterestApi.create(data),
        success: (response, dispatch) => {
            dispatch(push('/settings/interests'));
            return {
                payload: response.data,
            };
        },
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function load(filter = {}) {
    return {
        requestType: 'INTEREST_LIST',
        request: InterestApi.find(filter),
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadAutocomplete(filter = {}) {
    return {
        requestType: 'INTEREST_AUTOCOMPLETE',
        request: InterestApi.find(filter),
    };
}

/**
 * Update filter
 *
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateFilter(filter = {}) {
    return {
        type: INTEREST_LIST_UPDATE_FILTER,
        payload: filter,
    };
}

/**
 * Destroy
 *
 * @param {number} id
 * @returns {*}
 */
export function destroy(id) {
    return {
        requestType: 'INTEREST_DESTROY',
        request: InterestApi.destroy(id)
    };
}

/**
 * Load model data
 *
 * @param {number} id
 * @returns {*}
 */
export function loadData(id) {
    return {
        requestType: 'INTEREST_DATA',
        request: InterestApi.loadData(id),
    };
}

/**
 * Update model data
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function updateData(data) {
    const { id, ...values } = data;
    return {
        requestType: 'INTEREST_UPDATE',
        request: InterestApi.updateData(id, values),
        success: (response, dispatch) => {
            dispatch(push('/settings/interests'));
            return {
                payload: response.data,
            };
        },
    };
}



// WEBPACK FOOTER //
// ./src/actions/interest.js